<nav class="navDefault" fxLayout fxLayoutAlign="space-between center">
  <div class="navDefault_container">
    <button
      (click)="ga4Dispatch('sobre')"
      routerLink="/kore/metodo"
      class="navDefault_container_button"
      mat-button
    >
      sobre
      <span class="caret"></span>
    </button>
    <button
      (click)="ga4Dispatch('studios')"
      routerLink="/unidades"
      class="navDefault_container_button"
      mat-button
    >
      studios
      <span class="caret"></span>
    </button>
    <!--  <button routerLink="/instrutores" class="navDefault_container_button" mat-button>instrutores
      <span class="caret"></span>
    </button> -->
    <!-- <button (click)="goToPage('https://www.franquiaskore.com.br/')" class="navDefault_container_button lb"
      mat-button>franquias
      <span class="caret"></span>
    </button> -->
    <button
      (click)="ga4Dispatch('programa de fidelidade')"
      routerLink="/kore-eventos/kore-fidelidade"
      class="navDefault_container_button lb"
      mat-button
    >
      programa fidelidade
      <span class="caret"></span>
    </button>
    <button
      (click)="ga4Dispatch('velonews')"
      routerLink="/kore-eventos"
      class="navDefault_container_button lb"
      mat-button
    >
      kore news
      <span class="caret"></span>
    </button>
    <!-- <button (click)="goToPage('https://aulas.sweatify.com.br/cadastro')" class="navDefault_container_button lb"
      mat-button>kore at home
      <span class="caret"></span>
    </button> -->

    <ng-container *ngIf="isLoggedIn">
      <button
        (click)="ga4Dispatch('bring a friend')"
        routerLink="/minha-conta/bring-a-friend"
        class="navDefault_container_button lb"
        mat-button
      >
        bring a friend
        <span class="caret"></span>
      </button>
    </ng-container>

    <button
      (click)="
        ga4Dispatch('essentials');
        goToPage('https://hub.studiokore.com.br/essentials')
      "
      class="navDefault_container_button lb"
      mat-button
    >
      essentials
    </button>

    <ae2-bag>
      <ng-template #templateBagRef let-total="total">
        <button
          (click)="ga4Dispatch('bag')"
          routerLink="/checkout"
          class="navDefault_container_button bi"
          mat-button
        >
          <i class="bai">{{ total }}</i>
        </button>
      </ng-template>
    </ae2-bag>
    <ng-container *ngIf="isLoggedIn">
      <button
        (click)="logOut()"
        class="navDefault_container_button lb"
        mat-button
      >
        sair
        <span class="caret"></span>
      </button>
    </ng-container>
  </div>
  <div class="navDefault_container_right" fxLayout>
    <ng-container *ngIf="isLoggedIn">
      <ng-container *ngIf="!authStore?.isImpersonate">
        <div fxLayout fxLayoutAlign="center center">
          <div class="ae-total-name">
            <button
              [ae2Ga4Event]="'navigation'"
              [ga4Params]="{
                event_type: 'interaction',
                section: 'menu',
                element_type: 'link',
                element_label: 'minha conta',
                url_link: '/minha-conta/meus-dados'
              }"
              routerLink="/minha-conta/meus-dados"
              mat-button
            >
              {{ authStore?.user?.firstName }}
            </button>
          </div>

          <ng-container
            *ngIf="authStore?.user?.unitInfo?.vaccineNeeded && isShowButtonMask"
          >
            <div>
              <button
                class="noShadow covid19"
                mat-mini-fab
                (click)="openModalCovid()"
              >
                <div class="maskImage {{ colorButtonFloat() }}"></div>
              </button>
            </div>
          </ng-container>

          <ae2-total-credits-component [positionX]="start">
            <ng-template #templateTotalCredits let-data>
              <div class="ae-total-credits">
                <ng-container *ngIf="data?.isLogged">
                  <ng-container *ngIf="data?.isUnlimited">
                    <button
                      class="noShadow"
                      mat-mini-fab
                      color="primary"
                      (click)="data?.openPopOver()"
                    >
                      <mat-icon>all_inclusive</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="!data?.isUnlimited">
                    <button
                      class="noShadow"
                      mat-mini-fab
                      color="primary"
                      (click)="data?.openPopOver()"
                    >
                      {{ data?.totalCredits }}
                    </button>
                  </ng-container>
                </ng-container>
              </div>
            </ng-template>
            <ng-template #templateTotalCreditsPopOver let-data>
              <div class="totalCredits">
                <div class="totalCredits-button">
                  <mat-icon
                    class="totalCredits-button-close"
                    (click)="data?.closeOverlay()"
                    >close</mat-icon
                  >
                </div>
                <div class="totalCredits-box">
                  <p class="totalCredits-box-title">Créditos Disponíveis</p>
                  <mat-list role="list">
                    <ng-container *ngFor="let package of data?.packages">
                      <mat-list-item
                        class="totalCredits-box-itemlist"
                        role="listitem"
                      >
                        <div class="totalCredits-box-itemlist-item">
                          {{ package?.creditTypeName }}
                        </div>
                        <div class="totalCredits-box-itemlist-number">
                          <ng-container *ngIf="package?.isUnlimited">
                            <span class="infinityIcon">&infin;</span>
                          </ng-container>
                          <ng-container *ngIf="!package?.isUnlimited">
                            {{ package?.creditsAvailable }}
                          </ng-container>
                        </div>
                      </mat-list-item>
                    </ng-container>
                  </mat-list>
                  <div class="totalCredits-buy">
                    <button
                      [ae2Ga4Event]="'call_to_action'"
                      [ga4Params]="{
                        event_type: 'interaction',
                        journey: 'compra',
                        section: 'submenu',
                        element_type: 'botao',
                        element_label: 'comprar mais',
                        url_link: '/pacotes'
                      }"
                      class="noShadow boldClass"
                      mat-raised-button
                      color="primary"
                      routerLink="/pacotes"
                    >
                      comprar mais
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ae2-total-credits-component>
        </div>
      </ng-container>
      <ng-container *ngIf="authStore?.user?.isImpersonate">
        <div fxLayout fxLayoutAlign="center center">
          <div class="ae-total-name">
            <button
              [ae2Ga4Event]="'navigation'"
              [ga4Params]="{
                event_type: 'interaction',
                section: 'menu',
                element_type: 'link',
                element_label: 'minha conta',
                url_link: '/minha-conta/meus-dados'
              }"
              routerLink="/minha-conta/meus-dados"
              mat-button
            >
              {{ authStore?.user?.impersonatorName }} ({{
                authStore?.user?.firstName
              }})
            </button>
          </div>
          <div class="ae-total-credits">
            {{ authStore?.totalCredits ? authStore?.totalCredits : "0" }}
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isLoggedIn">
      <div class="navDefault_container_right_content">
        <button
          [ae2Ga4Event]="'view_modal'"
          [ga4Params]="{
            modal_name: 'login'
          }"
          (click)="openInSignIn()"
          class="navDefault_container_right_content_button"
          mat-button
        >
          login
          <span class="caret"></span>
        </button>
        <button
          [ae2Ga4Event]="'view_modal'"
          [ga4Params]="{
            modal_name: 'cadastro'
          }"
          (click)="openInSignUp()"
          class="navDefault_container_right_content_button"
          mat-button
        >
          cadastro
          <span class="caret"></span>
        </button>
      </div>
    </ng-container>
    <div class="navDefault_container_right_content butons-right">
      <button
        (click)="ga4BuyDispatch()"
        routerLink="/pacotes"
        class="navDefault_container_right_content_button color-white boldClass"
        mat-button
      >
        comprar
        <span class="caret"></span>
      </button>
      <button
        class="navDefault_container_right_content_button color-white boldClass"
        mat-button
        (click)="openPopOver()"
      >
        <app-unit-selection-component
          [openInComponent]="false"
        ></app-unit-selection-component>
        <span class="caret"></span>
      </button>
    </div>
  </div>
</nav>
